interface LogoProps {
  className?: string;
  showText?: boolean;
  /**
   * Surface tone the logo sits on. 'auto' (default) reads the
   * textColor heuristic so most callers don't have to think.
   *   - 'light' surface (white/court-white) → dark-ink wordmark
   *   - 'dark'  surface (navy/photo)        → light-ink wordmark
   */
  variant?: 'auto' | 'light' | 'dark';
  /**
   * Legacy prop. Used as a hint for `variant: 'auto'` only. Pass a
   * Tailwind text-color class — if it contains "white" we assume a
   * dark surface and use the light-ink wordmark.
   */
  textColor?: string;
}

/**
 * Deuce wordmark. Uses the brand lockup PNGs under /brand/ so the
 * Dubai-stencil typography stays pixel-perfect.
 *
 * Asset naming follows the design bundle:
 *   - logo-light.png — dark wordmark on light surface
 *   - logo-dark.png  — light wordmark on dark surface
 */
export default function Logo({
  className = 'h-9',
  variant = 'auto',
  textColor = 'text-white',
}: LogoProps) {
  const onDarkSurface = variant === 'auto'
    ? textColor.includes('white') || textColor.includes('court-white')
    : variant === 'dark';
  const src = onDarkSurface ? '/brand/logo-dark.png' : '/brand/logo-light.png';

  // The wordmark PNG is wide (~4:1). Force object-contain so callers
  // that pass square Tailwind classes (legacy w-12 h-12 etc) get a
  // proportional render instead of a squashed lockup. Width is left
  // free unless the caller pins it.
  return (
    <img
      src={src}
      alt="Deuce"
      className={`${className} object-contain`}
      style={{ width: 'auto' }}
    />
  );
}

